import React from 'react'
import QuestionCard from '../shared/QuestionCard'

const ReadingComprehensionPreview = ({ data }) => {
    const { questions = [] } = data

    return (
        <>
            {questions.map((question, index) => (
                <QuestionCard
                    key={question.id}
                    question={question}
                    questionNumber={index + 1}
                />
            ))}
        </>
    )
}

export default ReadingComprehensionPreview
